import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { useLanguage } from '../i18n/LanguageContext';
interface PrivacyPolicyPageProps {
  onNavigate: (page: string) => void;
}
export function PrivacyPolicyPage({
  onNavigate
}: PrivacyPolicyPageProps) {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-25969">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-25970">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25971">
          <Breadcrumbs items={[{
          label: t('legal.backToHome'),
          onClick: () => onNavigate('home')
        }, {
          label: t('legal.privacy.title')
        }]} className="mb-8" data-id="element-25972" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-25973">
            {t('legal.privacy.title')}
          </h1>
          <p className="text-slate-500" data-id="element-25974">{t('legal.lastUpdated')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-25975">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-25976">
          <h2 data-id="element-25977">{t('legal.privacy.s1.title')}</h2>
          <p data-id="element-25978">{t('legal.privacy.s1.p1')}</p>

          <h2 data-id="element-25979">{t('legal.privacy.s2.title')}</h2>
          <p data-id="element-25980">{t('legal.privacy.s2.p1')}</p>
          <ul data-id="element-25981">
            <li data-id="element-25982">{t('legal.privacy.s2.l1')}</li>
            <li data-id="element-25983">{t('legal.privacy.s2.l2')}</li>
            <li data-id="element-25984">{t('legal.privacy.s2.l3')}</li>
          </ul>

          <h2 data-id="element-25985">{t('legal.privacy.s3.title')}</h2>
          <p data-id="element-25986">{t('legal.privacy.s3.p1')}</p>
          <ul data-id="element-25987">
            <li data-id="element-25988">{t('legal.privacy.s3.l1')}</li>
            <li data-id="element-25989">{t('legal.privacy.s3.l2')}</li>
            <li data-id="element-25990">{t('legal.privacy.s3.l3')}</li>
            <li data-id="element-25991">{t('legal.privacy.s3.l4')}</li>
          </ul>

          <h2 data-id="element-25992">{t('legal.privacy.s4.title')}</h2>
          <p data-id="element-25993">{t('legal.privacy.s4.p1')}</p>

          <h2 data-id="element-25994">{t('legal.privacy.s5.title')}</h2>
          <p data-id="element-25995">{t('legal.privacy.s5.p1')}</p>

          <h2 data-id="element-25996">{t('legal.privacy.s6.title')}</h2>
          <p data-id="element-25997">{t('legal.privacy.s6.p1')}</p>
          <ul data-id="element-25998">
            <li data-id="element-25999">{t('legal.privacy.s6.l1')}</li>
            <li data-id="element-26000">{t('legal.privacy.s6.l2')}</li>
            <li data-id="element-26001">{t('legal.privacy.s6.l3')}</li>
          </ul>

          <h2 data-id="element-26002">{t('legal.privacy.s7.title')}</h2>
          <p data-id="element-26003">{t('legal.privacy.s7.p1')}</p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-26004">
          <button onClick={() => onNavigate('terms')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-26005">
            {t('legal.terms.title')} →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-26006">
            {t('legal.contactUs')}
          </button>
        </div>
      </div>
    </div>;
}